import { render, staticRenderFns } from "./DeleteMemberConfirmationModal.vue?vue&type=template&id=40cfe89f&scoped=true&"
import script from "./DeleteMemberConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteMemberConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteMemberConfirmationModal.vue?vue&type=style&index=0&id=40cfe89f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cfe89f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40cfe89f')) {
      api.createRecord('40cfe89f', component.options)
    } else {
      api.reload('40cfe89f', component.options)
    }
    module.hot.accept("./DeleteMemberConfirmationModal.vue?vue&type=template&id=40cfe89f&scoped=true&", function () {
      api.rerender('40cfe89f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/DeleteMemberConfirmationModal.vue"
export default component.exports